import { render, staticRenderFns } from "./vipUsedReport.vue?vue&type=template&id=0630bd85&scoped=true&"
import script from "./vipUsedReport.vue?vue&type=script&lang=js&"
export * from "./vipUsedReport.vue?vue&type=script&lang=js&"
import style0 from "./vipUsedReport.vue?vue&type=style&index=0&id=0630bd85&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630bd85",
  null
  
)

export default component.exports